import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LegaleIncaricato } from '../../../models/legale-incaricato';

@Component({
    selector: '[add_doc_to_legale]',
  templateUrl: 'add-to-legale.component.html',
})

export class AddDocumentoToLegaleComponent {
  @Input()
  legaleIncaricato: LegaleIncaricato;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(legaleIncaricato: LegaleIncaricato) {
    this.onClickAddToEntity.emit(legaleIncaricato);
  }
}
